import type { DocPageContent } from '../docs-content'

const page = {
  order: 16,
  slug: 'scene-browser',
  title: '场景浏览器与 AI 分析',
  description: '分析媒体、检测场景、搜索说明文字、语义和色彩。',
  category: '创意工具',
  sections: [
    {
      title: '准备场景',
      items: [
        '对需要可搜索的片段运行 AI 分析。',
        '使用场景检测来分割或索引有意义的时刻。',
        '当说明文字或场景数据需要刷新时重新分析媒体。',
      ],
    },
    {
      title: '搜索模式',
      items: [
        '使用"关键词"搜索进行精确文本匹配。',
        '使用"语义"搜索进行基于含义的匹配。',
        '使用"色彩"搜索和调色板匹配进行视觉匹配。',
        '将搜索范围限制为单个媒体项目或所有已分析的媒体。',
      ],
    },
    {
      title: '使用结果',
      items: [
        '查看匹配徽章和置信度等级。',
        '点击场景在源监视器中预览。',
        '当某个时刻有用时，将场景拖回时间线。',
      ],
    },
  ],
} satisfies DocPageContent

export default page